import moment from 'moment/moment';
import store from '@/store/store';
import { getFicheProduitReseauTempo } from '@/api/reseaux';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';

export default async function exporterFicheProduit(data) {
  const response = await getFicheProduitReseauTempo({
    ...data,
    dateDeVisualisation: moment(store.getters['venteReseauxTempo/dateDeVisualisation']).format('YYYYMMDD'),
    anneeSemaine: getAnneeSemaineFromDate(store.getters['venteReseauxTempo/dateDeVisualisation']),
    socCode: store.getters['user/idSociete'],
  });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(response.data);
  const disposition = response.request.getResponseHeader('Content-Disposition');
  link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
  link.click();
}



// WEBPACK FOOTER //
// ./src/services/reseauxTempo/exporterFicheProduit.js